import { darkenHex, getContrastTextColor, isValidHex } from '@/lib/colorUtils'
import { type InteractiveButton } from '@/types/interactiveVideo'

const DEFAULT_BG = 'rgba(0,0,0,0.55)'
const DEFAULT_BG_HOVER = 'rgba(0,0,0,0.7)'

/**
 * 分岐ボタンの色を決める。3段フォールバック:
 * ①個別ボタン色（`style.backgroundColor`）→ ②テナントデフォルト色 → ③システム既定（黒半透明）。
 *
 * ②は**ボタンの種類を問わず**適用する。かつては外部リンクボタンにだけ効かせていたが、
 * CTA を置かないシナリオではせっかく登録したブランドカラーがどこにも出ず、
 * 「登録した色をどの場面でも呼び出せる」という本来の目的を満たせなかった。
 * 分岐ボタンと CTA で色を分けたい場合は、個別ボタン色（①）で上書きする。
 *
 * ①②が有効HEXのときは文字色を自動判定し、hover で暗くする。
 * ポップアップ／ボックスの `ButtonOverlay` とワイドの `WideBranchOverlay` で共有する。
 */
export function resolveBranchButtonStyle(
  button: InteractiveButton,
  defaultButtonColor: string | null | undefined,
  isHover: boolean,
): { backgroundColor: string; color: string } {
  const bgColor = button.style?.backgroundColor

  const resolvedColor =
    typeof bgColor === 'string' && isValidHex(bgColor)
      ? bgColor
      : typeof defaultButtonColor === 'string' && isValidHex(defaultButtonColor)
        ? defaultButtonColor
        : null

  if (resolvedColor) {
    return {
      backgroundColor: isHover ? darkenHex(resolvedColor) : resolvedColor,
      color: getContrastTextColor(resolvedColor),
    }
  }

  return {
    backgroundColor: isHover ? DEFAULT_BG_HOVER : DEFAULT_BG,
    color: '#FFFFFF',
  }
}
